import React, { useState, useEffect } from "react";
import ConditionsTableRowHead from "./ConditionsTable/ConditionsTableRowHead";
import ConditionList from "./ConditionsTable/ConditionList";
import { table } from "../Shared/Styles";

import {
  subTitle,
  summary,
  hr,
} from "../Shared/Styles";

export default function Conditions({ conditionDetails }) {
  if (conditionDetails.length >= 1) {
    return (
      <div className="ConditionDetailsComponent">
        <h3 style={subTitle}>CONDITIONS</h3>
        <div>
          {conditionDetails.map((link) => (
            <>
              <div style={summary}>
                {link.lifeInsuredFirstName}{" "}
                {link.lifeInsuredSurName} <hr style={hr} />
              </div>

              <table style={table}>
                <div>
                  <ConditionsTableRowHead />
                
                  <ConditionList cl={link.conditionDetailSub} />
                </div>
              </table>
            </>
          ))}
        </div>
      </div>
    );
  } else if (conditionDetails.length < 1) {
    return (
      <div>
        <h3 style={subTitle}>CONDITIONS</h3>
        <p style={summary}>There are no loadings or exclusions.</p>
      </div>
    )
  }
}
